import * as Yup from 'yup'
import { string } from 'yup'
import i18n from 'i18next'
import { numberWithSpace } from 'utils/numberWithSpace'

const DESIRED_MIN_VALUE = 10000
const DESIRED_MAX_VALUE = 10000000

export const validationSchema = Yup.object().shape({
  desired_value: Yup.string()
    .typeError(/*'media_planner::form.desired_value.errors.required'*/)
    .test({
      name: 'min_max',
      test: function (value, ctx) {
        const { path, parent } = this
        const {
          desired_value_min = DESIRED_MIN_VALUE,
          desired_value_max = DESIRED_MAX_VALUE,
        } = parent ?? {}

        if (+value >= desired_value_min && +value <= desired_value_max) {
          return true
        } else if (+value < desired_value_min) {
          return ctx.createError({
            path,
            message: i18n.t('media_planner::form.desired_value.errors.min', {
              number: numberWithSpace(desired_value_min),
            }),
          })
        } else {
          return ctx.createError({
            path,
            message: i18n.t('media_planner::form.desired_value.errors.max', {
              number: numberWithSpace(desired_value_max),
            }),
          })
        }
      },
    })
    .required('media_planner::form.desired_value.errors.required'),
  target: Yup.string().required('media_planner::form.target.errors.required'),
  industry_id: Yup.string().required(
    'media_planner::form.target.errors.required',
  ),
  sub_industry_id: Yup.string().required(
    'media_planner::form.target.errors.required',
  ),
  platform_level_1_ids: Yup.array()
    .of(string())
    .min(1, 'media_planner::form.target.errors.required')
    .required('media_planner::form.target.errors.required'),
  platform_level_2_ids: Yup.array()
    .of(string())
    .min(1, 'media_planner::form.target.errors.required')
    .required('media_planner::form.target.errors.required'),
  strategy_level_1_id: Yup.string().required(
    'media_planner::form.target.errors.required',
  ),
})
